<template>
  <div>
    <div class="background" :style="{ backgroundImage: `url(${background})` }">
      <kinesis-container class="pcontainer">
        <kinesis-element class="svgcontainer" :strength="-300" axis="x">
          <Biker class="biker" />
        </kinesis-element>
      </kinesis-container>
    </div>
    <div class="credits">
      <a
        href="https://www.freepik.com/free-vector/bicycle-race-egypt-with-flat-design_1310233.htm"
        target="_blank"
        >Biker</a
      >
      <a
        href="https://www.freepik.com/free-vector/flat-farm-landscape_4595233.htm"
        target="_blank"
        >Landscape</a
      >
    </div>
  </div>
</template>

<script>
import { KinesisContainer } from "vue-kinesis";
import { KinesisElement } from "vue-kinesis";
import background from "@/assets/landscape.jpg";
import Biker from "./Biker.vue";
export default {
  components: {
    KinesisContainer,
    KinesisElement,
    Biker
  },
  data() {
    return {
      background
    };
  }
};
</script>

<style lang="scss" scoped>
.biker {
  height: 200px;
}

.background {
  background-position: bottom;
  background-size: cover;
  height: 430px;
  border-radius: 10px;
  overflow: hidden;
  max-width: 800px;
  margin: auto;
}

.pcontainer {
  height: 100%;
}

.svgcontainer {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.credits {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.credits a {
  color: white;
  text-decoration: none;
  font-size: 12px;
}

.credits a:hover {
  text-decoration: underline;
}
</style>
